<template>
  <div>
    <h1 class="text-h1 pb-16">Great work! Your job is ready to share</h1>
    <p>We've generated a title and description to make it easier</p>
    <NoteBox header="What's next?">
      <ol class="leading-8 text-body-2 list-decimal pl-20">
        <li>Confirm the details and we'll share your job with local sitters</li>
        <li>Interested sitters will respond to your job</li>
        <li v-if="isBasic">Upgrade to Premium to directly connect with sitters</li>
        <li v-else>Connect with sitters who meet your needs</li>
      </ol>
    </NoteBox>
  </div>
</template>

<script>
import NoteBox from '@/components/note_box/NoteBox.vue';

export default {
  name: 'JobPostConfirmTransitionText',
  components: {
    NoteBox,
  },
  computed: {
    isBasic() {
      return this.$store.getters['account/getAccount'].isBasic?.() || false;
    },
  },
};
</script>
